import { Typography } from '@mui/material';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './TeacherAssignedStudentNoSelectedDateMessage.scss';

const defaultProps = {
  selectedDates: {},
};

const TeacherAssignedStudentNoLessonMessage = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { selectedDates } = mergedProps;
  return (
    <div className='teacher-assigned-student-no-selected-date-message'>
      {(!selectedDates || !selectedDates.dates || selectedDates.dates.length === 0) && (
        <Typography className='no-seleted-lessons-title' variant='h5'>
          Choose a date option to display assignments
        </Typography>
      )}
    </div>
  );
};

export default TeacherAssignedStudentNoLessonMessage;
